import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AsyncReduxState, initialAsyncReduxState } from '../../defaults';

export type ParticipateFormState = AsyncReduxState<{
    isSent: boolean;
}>;

const initialState: ParticipateFormState = {
    ...initialAsyncReduxState,
    isSent: false,
};

const participateFormSlice = createSlice({
    name: 'participateFormSlice',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ParticipateFormState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ParticipateFormState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): ParticipateFormState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setIsSent(state, action: PayloadAction<boolean>): ParticipateFormState {
            return {
                ...state,
                isSent: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setIsSuccessful,
    setError,
    setIsSent,
} = participateFormSlice.actions;

export default participateFormSlice;
